import React, { useEffect, useState } from "react";
import "./HotelDetails.css";
import HotelGallery from "../HotelGallery/HotelGallery";
import { axiosPost } from "../../../../utils/apis/api";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { SpinnerLoading } from "../../../../components";
import { useTranslation } from "../../../../contexts/TranslationContext";
import { X } from "react-bootstrap-icons";

const HotelDetails = ({
  url,
  packageId,
  onSuccess,
  hotel,
  onBack,
  dates,
  nights,
  selectedDestination,
  onReturn,
  fetchFromApi,
  dataFromList,
  checkin,
  checkout
}) => {

 

  const maxStars = 5;
  const [loading, setLoading] = useState(false);
  const [preBookId, setPrebookId] = useState(null);
  const [hotelId, setHotelId] = useState(null);
  const [hotelDetails, setHotelDetails] = useState(null);
  const [hotelRoom, setHotelRoom] = useState(null);
  const [rating, setRating] = useState()
  const { t } = useTranslation();
  const [showDropdown, setShowDropdown] = useState(false);

  const navigate = useNavigate();

  const facilities = dataFromList?.features || hotelDetails?.HotelFacilities || [];
  const topFacilities = facilities.slice(0, 10);

  const nightsCount = dayjs(checkout).diff(dayjs(checkin), "day");
  const renderStars = (rate) => {
    const stars = [];
    const fullStars = Math.floor(rate);
    const hasHalfStar = rate % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={`full-${i}`} className="star">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
          >
            <path
              d="M14.76 5.51739L10.7928 4.94083L9.01939 1.34551C8.97095 1.24708 8.89126 1.16739 8.79283 1.11895C8.54595 0.997076 8.24595 1.09864 8.12251 1.34551L6.34908 4.94083L2.38189 5.51739C2.27251 5.53301 2.17251 5.58458 2.09595 5.6627C2.00339 5.75784 1.95239 5.88583 1.95415 6.01855C1.9559 6.15127 2.01028 6.27786 2.10533 6.37051L4.97564 9.16895L4.29751 13.1205C4.28161 13.2124 4.29178 13.307 4.32688 13.3934C4.36197 13.4798 4.42058 13.5547 4.49606 13.6095C4.57154 13.6644 4.66087 13.6969 4.75392 13.7036C4.84697 13.7102 4.94002 13.6906 5.02251 13.6471L8.57095 11.7815L12.1194 13.6471C12.2163 13.6986 12.3288 13.7158 12.4366 13.6971C12.7084 13.6502 12.8913 13.3924 12.8444 13.1205L12.1663 9.16895L15.0366 6.37051C15.1147 6.29395 15.1663 6.19395 15.1819 6.08458C15.2241 5.81114 15.0334 5.55801 14.76 5.51739Z"
              fill="#CF9F47"
            />
          </svg>
        </span>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <span key="half" className="star">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
          >
            <g clip-path="url(#clip0_754_601)">
              <path
                d="M13.9598 6.81844C14.1108 6.70593 14.2228 6.54898 14.2802 6.36959C14.3375 6.1902 14.3372 5.99737 14.2794 5.81813C14.2216 5.6389 14.1092 5.48225 13.9578 5.37015C13.8065 5.25805 13.6239 5.19612 13.4356 5.19304L9.77847 5.05488C9.76048 5.05364 9.74325 5.04723 9.72883 5.03641C9.71441 5.0256 9.70342 5.01085 9.6972 4.99393L8.43345 1.5806C8.36996 1.40694 8.25463 1.25699 8.10309 1.15104C7.95155 1.0451 7.77111 0.988281 7.58621 0.988281C7.40131 0.988281 7.22087 1.0451 7.06933 1.15104C6.91779 1.25699 6.80247 1.40694 6.73897 1.5806L5.47929 5.00612C5.47307 5.02304 5.46208 5.03779 5.44766 5.0486C5.43324 5.05942 5.416 5.06583 5.39802 5.06707L1.74088 5.20523C1.55258 5.20831 1.36996 5.27024 1.21864 5.38234C1.06731 5.49444 0.954862 5.65109 0.897059 5.83032C0.839256 6.00956 0.838996 6.20239 0.896317 6.38178C0.953638 6.56117 1.06566 6.71812 1.21669 6.83063L4.08551 9.08587C4.09987 9.09717 4.1106 9.11243 4.11638 9.12976C4.12216 9.14709 4.12273 9.16574 4.11802 9.18339L3.13059 12.6821C3.07943 12.8602 3.08438 13.0498 3.14479 13.2251C3.2052 13.4003 3.31813 13.5527 3.46821 13.6615C3.61829 13.7703 3.79824 13.8302 3.98358 13.8331C4.16892 13.836 4.35065 13.7817 4.50405 13.6776L7.53542 11.6459C7.55035 11.6356 7.56807 11.63 7.58621 11.63C7.60436 11.63 7.62207 11.6356 7.63701 11.6459L10.6684 13.6776C10.8197 13.7852 11.0008 13.8431 11.1865 13.8431C11.3722 13.8431 11.5532 13.7852 11.7046 13.6776C11.8547 13.5699 11.9677 13.4182 12.0281 13.2436C12.0885 13.0689 12.0933 12.8799 12.0418 12.7024L11.0463 9.19152C11.041 9.17389 11.0413 9.15507 11.0471 9.13762C11.0529 9.12016 11.064 9.10493 11.0788 9.094L13.9598 6.81844ZM10.262 9.39063L11.2576 12.9015C11.2657 12.9202 11.2671 12.9412 11.2616 12.9609C11.2562 12.9806 11.2441 12.9978 11.2275 13.0097C11.2108 13.0216 11.1906 13.0274 11.1702 13.0262C11.1498 13.025 11.1305 13.0168 11.1154 13.0031L8.08399 10.9713C7.93526 10.8706 7.75974 10.8168 7.58012 10.8169V1.80409C7.59925 1.80254 7.61831 1.8078 7.63393 1.81896C7.64955 1.83012 7.66072 1.84644 7.66545 1.86504L8.9292 5.28244C8.99041 5.45087 9.1004 5.59725 9.24515 5.70291C9.38989 5.80857 9.56282 5.86873 9.74189 5.87571L13.399 6.01387C13.4182 6.01356 13.4369 6.01939 13.4524 6.03051C13.468 6.04162 13.4796 6.05743 13.4855 6.07562C13.4914 6.09381 13.4913 6.11341 13.4853 6.13155C13.4792 6.14969 13.4675 6.16542 13.4519 6.17641L10.583 8.43165C10.4394 8.54076 10.332 8.69061 10.2747 8.86166C10.2175 9.0327 10.213 9.21703 10.262 9.39063Z"
                fill="#CF9F47"
              />
            </g>
            <defs defs>
              <clipPath id="clip0_754_601">
                <rect
                  width="14.6286"
                  height="14.6286"
                  fill="white"
                  transform="translate(0.143555)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      );
    }

    const emptyStars = maxStars - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(
        <span key={`empty-${i}`} className="star">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
          >
            <g clip-path="url(#clip0_754_601)">
              <path
                d="M13.9598 6.81844C14.1108 6.70593 14.2228 6.54898 14.2802 6.36959C14.3375 6.1902 14.3372 5.99737 14.2794 5.81813C14.2216 5.6389 14.1092 5.48225 13.9578 5.37015C13.8065 5.25805 13.6239 5.19612 13.4356 5.19304L9.77847 5.05488C9.76048 5.05364 9.74325 5.04723 9.72883 5.03641C9.71441 5.0256 9.70342 5.01085 9.6972 4.99393L8.43345 1.5806C8.36996 1.40694 8.25463 1.25699 8.10309 1.15104C7.95155 1.0451 7.77111 0.988281 7.58621 0.988281C7.40131 0.988281 7.22087 1.0451 7.06933 1.15104C6.91779 1.25699 6.80247 1.40694 6.73897 1.5806L5.47929 5.00612C5.47307 5.02304 5.46208 5.03779 5.44766 5.0486C5.43324 5.05942 5.416 5.06583 5.39802 5.06707L1.74088 5.20523C1.55258 5.20831 1.36996 5.27024 1.21864 5.38234C1.06731 5.49444 0.954862 5.65109 0.897059 5.83032C0.839256 6.00956 0.838996 6.20239 0.896317 6.38178C0.953638 6.56117 1.06566 6.71812 1.21669 6.83063L4.08551 9.08587C4.09987 9.09717 4.1106 9.11243 4.11638 9.12976C4.12216 9.14709 4.12273 9.16574 4.11802 9.18339L3.13059 12.6821C3.07943 12.8602 3.08438 13.0498 3.14479 13.2251C3.2052 13.4003 3.31813 13.5527 3.46821 13.6615C3.61829 13.7703 3.79824 13.8302 3.98358 13.8331C4.16892 13.836 4.35065 13.7817 4.50405 13.6776L7.53542 11.6459C7.55035 11.6356 7.56807 11.63 7.58621 11.63C7.60436 11.63 7.62207 11.6356 7.63701 11.6459L10.6684 13.6776C10.8197 13.7852 11.0008 13.8431 11.1865 13.8431C11.3722 13.8431 11.5532 13.7852 11.7046 13.6776C11.8547 13.5699 11.9677 13.4182 12.0281 13.2436C12.0885 13.0689 12.0933 12.8799 12.0418 12.7024L11.0463 9.19152C11.041 9.17389 11.0413 9.15507 11.0471 9.13762C11.0529 9.12016 11.064 9.10493 11.0788 9.094L13.9598 6.81844Z"
                fill="none"
                stroke="#CF9F47"
                stroke-width="1"
              />
            </g>
            <defs>
              <clipPath id="clip0_754_601">
                <rect
                  width="14.6286"
                  height="14.6286"
                  fill="white"
                  transform="translate(0.143555)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
      );
    }

    return stars;
  };


  const dataFromListApi = async (prebookId, hotelId) => {
  setLoading(true);

  const payload = {
    componentType: "Hotel",
    component_id: hotelId,
    destination: dataFromList.selectedDestination,
    start_date: checkin
      ? dayjs(checkin).format("YYYY-MM-DD HH:mm:ss")
      : null,
    end_date: checkout
      ? dayjs(checkout).format("YYYY-MM-DD HH:mm:ss")
      : null,
    travelers: dataFromList.travelers,
    pre_book_id: prebookId,
  };

  try {
    const apiKey = Cookies.get("api_key");
    const apiSecret = Cookies.get("api_secret");
    const headers = {
      Authorization: `token ${apiKey}:${apiSecret}`,
    };

    const response = await axiosPost(
      `${url}/api/method/erpnext.selling.doctype.quotation.quotation.create_one_component_package_for_hotel_or_flight`,
      payload,
      headers
    );

    if (response.status === 200) {
      toast.success(t("AddedSuccessfully"), { position: "bottom-right" });
      onSuccess();
    } else {
      toast.error(
        response.message ?? t("ErrorOccurredWhileAddingReservation"),
        { position: "bottom-right" }
      );
    }
  } catch (error) {
    toast.error(error ?? t("ErrorOccurredWhileAddingReservation"), {
      position: "bottom-right",
    });
    console.error("Error:", error);
  }
  setLoading(false);
};


  const preBook = async (bookingCode) => {

    const apiKey = Cookies.get("api_key");
    const apiSecret = Cookies.get("api_secret");

    if (!apiKey || !apiSecret) {
      // حفظ الصفحة الحالية في state ليعاد التوجيه لها بعد login
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;
      const redirectUrl = currentPath + currentSearch;

      navigate("/login", { state: { from: redirectUrl } });
      return;
    }

    setLoading(true);

    const payload = {
      booking_code: bookingCode,
      payment_mode: "Limit",
    };
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
    
      const response = await axiosPost(
        `${url}/api/method/alltimes.www.hotel_api.prebook`,
        payload,
        headers
      );

      if (response.status === 200) {
        const result = response.data.result;
        if (result) {
          setPrebookId(response.data.result.prebook_id);
          setHotelId(response.data.result.hotel_id);
        }

        toast.success(t("ReservedSuccessfully"), {
          position: "bottom-right",
        });
      } else {
        setLoading(false);

        toast.error(response.message ?? t("ErrorOccurredWhileReservingThisRoom"), {
          position: "bottom-right",
        });
      }
    } catch (error) {
      setLoading(false);

      toast.error(error ?? t("ErrorOccurredWhileReservingThisRoom"), {
        position: "bottom-right",
      });
      console.error("Error:", error);
    }
  };

  const addComponentToQuot = async (items) => {
    setLoading(true);

    const payload = {
      quotation_id: packageId,
      items: items,
    };
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const response = await axiosPost(
        `${url}/api/method/erpnext.selling.doctype.quotation.quotation.add_items_to_quotation`,
        payload,
        headers
      );
   

      if (response.status === 200) {
        toast.success(t("AddedSuccessfully"), {
          position: "bottom-right",
        });
       
        onSuccess();
        //   onReturn();
      } else {
        toast.error(
          response.message ?? t("ErrorOccurredWhileAddingReservation"),
          {
            position: "bottom-right",
          }
        );
      }
    } catch (error) {
      toast.error(error ?? t("ErrorOccurredWhileAddingReservation"), {
        position: "bottom-right",
      });
      console.error("Error:", error);
    }
    setLoading(false);
  };

  const fetchHotelDetails = async () => {
    try {
      let apiUrl = `${url}/api/method/alltimes.www.hotel_api.booking_details`;

      setLoading(true);
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");
      var headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };
      const payload = {
        details_from: "prebook_id",
        prebook_id: hotel.prebook_docname,
        book_id: "",
      };
      const response = await axiosPost(
        apiUrl,
        payload,
        headers
      );
      const result = response.data.result;
      setHotelDetails(result.hotel_details);
      setHotelRoom(result.prebook_response[0]?.Rooms);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      return { data: null, error: error.message };
    }
  };

  useEffect(() => {
    if (preBookId && hotelId) {
      if (dataFromList) {
        dataFromListApi(preBookId, hotelId);
      } else {
          addComponentToQuot([
            {
              package_component_type: "Hotel",
              package_component_id: hotelId,
              destination_row_id: selectedDestination.primary_destination_row_id,
              date_from: dates?.startDate
                ? dayjs(dates.startDate).format("YYYY-MM-DD HH:mm:ss")
                : null,
              date_to: dates?.endDate
                ? dayjs(dates.endDate).format("YYYY-MM-DD HH:mm:ss")
                : null,
              from_destination: selectedDestination.location,
              to_destination: null,
              prebook_doctype: "Hotel Prebook",
              prebook_docname: preBookId,
            },
          ]);
        }
    }
  }, [preBookId, hotelId]);

  useEffect(() => {
    if (hotel) {
      setHotelDetails(hotel.HotelInfo);
      setHotelRoom(hotel.Rooms);
      setRating(hotel?.HotelInfo?.HotelRating);
    }
  }, [hotel]);

  useEffect(() => {
    if (dataFromList) {
      setHotelRoom(dataFromList?.rooms);
    }
  }, [dataFromList]);


  useEffect(() => {
    if (fetchFromApi) {
      fetchHotelDetails();
    }
  }, [fetchFromApi]);

  return loading ? (
    <div className="hotel-form-container">
      <button className="hotel-details-form-backbtn" onClick={onReturn}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 23 23"
          fill="none"
        >
          <path
            d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {t("BackToPlan")}
      </button>
      <div className="loading-container">
      <SpinnerLoading />
      </div>
    </div>
  ) : (
    <div className="hotel-details-form-container">
      <button className="hotel-details-form-backbtn" onClick={onReturn}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 23 23"
          fill="none"
        >
          <path
            d="M5.75 11.5H18.2083M5.75 11.5L9.58333 7.66671M5.75 11.5L9.58333 15.3334"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <div>
          {t("BackToPlan")}
        </div>
        
      </button>
      {
        dataFromList && (
          <div className="hotel-details-night">
           {dayjs(checkin).format("D MMMM")} - {dayjs(checkout).format("D MMMM")} {nightsCount} {nightsCount > 1 ? "Nights" : "Night"} in <span>{dataFromList.city}</span>
          </div>
        )
      }
      
      <div className="hotel-detail-rate" style={{ marginTop: `${dataFromList ? "10px" : "20px"}`}}>
        <div className="hotel-detail-stars">{renderStars(dataFromList ? dataFromList?.rating : rating)}</div>
        <span className="rating-number">{dataFromList ? dataFromList?.rating : rating}</span>
      </div>
      <div className="hotel-detail-title">{dataFromList ? dataFromList?.name : hotelDetails?.HotelName}</div>
      <div className="hotel-detail-location">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="12"
          viewBox="0 0 9 12"
          fill="none"
        >
          <path
            d="M3.5575 11.2421C3.8605 11.5122 4.1765 11.7591 4.5 12C4.8242 11.7623 5.13866 11.5094 5.4425 11.2421C5.949 10.7928 6.42567 10.3056 6.869 9.7841C7.891 8.57675 9 6.82651 9 4.8618C9 4.22334 8.8836 3.59113 8.65746 3.00127C8.43131 2.41141 8.09984 1.87545 7.68198 1.42399C7.26412 0.972528 6.76804 0.614411 6.22208 0.370082C5.67611 0.125754 5.09095 0 4.5 0C3.90905 0 3.32389 0.125754 2.77792 0.370082C2.23196 0.614411 1.73588 0.972528 1.31802 1.42399C0.900156 1.87545 0.568688 2.41141 0.342542 3.00127C0.116396 3.59113 -8.80582e-09 4.22334 0 4.8618C0 6.82651 1.109 8.57621 2.131 9.7841C2.57431 10.3058 3.05098 10.7926 3.5575 11.2421ZM4.5 6.61745C4.06902 6.61745 3.6557 6.43248 3.35095 6.10323C3.04621 5.77398 2.875 5.32743 2.875 4.8618C2.875 4.39617 3.04621 3.94962 3.35095 3.62037C3.6557 3.29112 4.06902 3.10615 4.5 3.10615C4.93098 3.10615 5.3443 3.29112 5.64905 3.62037C5.95379 3.94962 6.125 4.39617 6.125 4.8618C6.125 5.32743 5.95379 5.77398 5.64905 6.10323C5.3443 6.43248 4.93098 6.61745 4.5 6.61745Z"
            fill="#27346A"
          />
        </svg>
        <div>{dataFromList ? dataFromList?.address : hotelDetails?.Address}</div>
      </div>

      {(dataFromList?.Images || hotelDetails?.Images) && <HotelGallery hotel={dataFromList ? dataFromList : hotelDetails}  />}

     <div className="hotel-detail-title">{t("MostPopularFacilities")}</div>
      <div className="hotel-detail-facilities">
        {topFacilities.map((item, index) => (
          <div className="hotel-detail-facility" key={index}>
            {item}
          </div>
        ))}

        {facilities.length > 10 && (
          <div className="dropdown-wrapper">
            <button
              className="show-more-btn"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {showDropdown ? t("HideFacilities") : t("ShowAllFacilities")}
            </button>

            {showDropdown && (
              <div className="facilities-dropdown">
                {facilities.map((item, index) => (
                  <div className="hotel-detail-facility" key={index}>
                    {item}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>


      <div
        className="hotel-detail-desc"
        dangerouslySetInnerHTML={{ __html: dataFromList ? dataFromList?.dis : hotelDetails?.Description }}
      />

      <div className="hotel-detail-availability">
        <div className="hotel-detail-title">{t("Availability")}</div>
        <div className="hotel-detail-availability-desc">
          
          Prices converted to USD
        </div>
        <table class="hotel-detail-table">
          <thead>
            <tr class="hotel-detail-table-header">
              <th class="hotel-detail-table-cell name">{t("Name")}</th>
              <th class="hotel-detail-table-cell">{t("CancelPolicy")}</th>
              <th class="hotel-detail-table-cell">{t("Price")}</th>
              {!fetchFromApi && (
                <th class="hotel-detail-table-cell">{t("Reserve")}</th>
              )}
            </tr>
          </thead>
          <tbody>
            {hotelRoom &&
              hotelRoom.map((room, index) => (
                <tr key={index} className="hotel-detail-table-row">
                  <td className="hotel-detail-table-cell name">
                    {room.Name &&
                      room.Name.map((name, nameIndex) => (
                        <div key={nameIndex}>{name}</div>
                      ))}
                  </td>

                  <td className="hotel-detail-table-cell">
                  {room.CancelPolicies?.length > 0 ? (
                    <div>
                      {room.CancelPolicies.map((policy, idx) => (
                        <div key={idx}>
                         {t("IfCancellationOccursAfter")} {" "}<strong>{policy.FromDate}</strong>, {t("AChargeOf")}{" "}
                          {policy.ChargeType === "Percentage"
                            ? `${policy.CancellationCharge}%`
                            : `$${policy.CancellationCharge.toFixed(2)}`} {t("WillApplyToTheAmount")}.
                        </div>
                      ))}
                    </div>
                  ) : (
                    t("NotSpecified")
                  )}
                </td>

                  <td className="hotel-detail-table-cell">
                    {room.TotalFare} $
                    {/* {room.DayRates &&
                      room.DayRates.map((dayRateGroup, groupIndex) => (
                        <div key={groupIndex}>
                          {dayRateGroup.map((rate, rateIndex) => (
                            <div key={rateIndex}>
                              ${rate.BasePrice.toFixed(2)}
                            </div>
                          ))}
                        </div>
                      ))} */}
                  </td>

                  {!fetchFromApi && (
                    <td className="hotel-detail-table-cell">
                      <button
                        className="reserve-btn"
                        disabled={loading}
                        onClick={() => {
                          preBook(room.BookingCode);
                        }}
                      >
                        {loading ? t("Loading")+".." : t("Reserve")}
                      </button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default HotelDetails;
